import { getLocation } from 'jsonc-parser'

/**
 * Given JSON text and a character offset within it, return the JSON path
 * (array of string keys / numeric indices) that the cursor is inside.
 */
export function pathAtOffset(text: string, offset: number): (string | number)[] {
  try {
    const loc = getLocation(text, offset)
    return (loc.path ?? []) as (string | number)[]
  } catch {
    return []
  }
}

/**
 * Find the nearest existing node id matching a JSON path. Walks from the
 * deepest to shallowest until a match is found.
 */
export function nearestNodeIdForPath(
  path: (string | number)[],
  nodeIds: Set<string>,
  pathToId: (p: (string | number)[]) => string,
): string | null {
  for (let i = path.length; i >= 0; i--) {
    const id = pathToId(path.slice(0, i))
    if (nodeIds.has(id)) return id
  }
  return null
}

/**
 * Like nearestNodeIdForPath, but also returns the field key *within* that
 * node (if any) — the next path segment after the matched prefix.
 */
export function nearestNodeMatch(
  path: (string | number)[],
  nodeIds: Set<string>,
  pathToId: (p: (string | number)[]) => string,
): { id: string; fieldKey: string | null } | null {
  for (let i = path.length; i >= 0; i--) {
    const id = pathToId(path.slice(0, i))
    if (nodeIds.has(id)) {
      const fieldKey = i < path.length ? String(path[i]) : null
      return { id, fieldKey }
    }
  }
  return null
}
